<template>
  <div class="pa-ovl" role="dialog" aria-modal="true" aria-labelledby="pa-site-access-title" @click.self="$emit('close')">
    <!-- design pa-app.jsx fixAccess / Modal: key icon, muted body with the how-to, text box, footnote -->
    <div class="pa-cmodal">
      <div class="pa-cmodal__icon"><i class="material-icons" aria-hidden="true">vpn_key</i></div>
      <h3 id="pa-site-access-title" class="pa-cmodal__title">Update site access</h3>
      <p class="pa-cmodal__body">
        Our publishing team can no longer log in to {{ siteName || 'your site' }}. Re-add our dedicated editor
        account, then tell us to retry.
      </p>
      <p class="pa-cmodal__body pa-site-access__how">
        <span>On WordPress: Users &gt; Add New &gt; Role: Editor, email devs@pageoptimizer.pro.</span>
        <span>
          Other CMS: invite devs@pageoptimizer.pro with editor (not admin) rights, or share a new login through
          the secure link in your welcome email.
        </span>
      </p>
      <div v-if="blockedNote" class="pa-cmodal__note"><b>What we need:</b> {{ blockedNote }}</div>
      <textarea
        ref="note"
        v-model="note"
        class="pa-cmodal__text"
        maxlength="4000"
        placeholder="Optional: login URL, username or anything we should know"
        :disabled="busy"
      ></textarea>
      <p class="pa-cmodal__foot">
        We check access within 1 business day and publishing resumes the same day we can log in. Never paste
        passwords here.
      </p>
      <div class="pa-cmodal__acts">
        <button type="button" class="pa-btn pa-btn--out" :disabled="busy" @click="$emit('close')">Later</button>
        <button
          type="button"
          class="pa-btn pa-btn--orange"
          :disabled="busy"
          @click="$emit('confirm', { note: (note || '').trim() })"
        >Done, please retry</button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * "Update site access" (design pa-app.jsx fixAccess): the client restores our editor account and
 * asks us to retry publishing. Emits `confirm` with { note }.
 */
export default {
  name: 'PopAuthoritySiteAccessModal',
  props: {
    /** Shown in the first sentence; "your site" when the project name is not known. */
    siteName: { type: String, default: '' },
    blockedNote: { type: String, default: '' },
    busy: { type: Boolean, default: false },
  },
  data () {
    return {
      note: '',
    }
  },
}
</script>

<style lang="scss" scoped>
@import './setup/setup.scss';
@import './setup/designModal.scss';

/* the two how-to lines of the design's body, one under the other */
.pa-site-access__how {
  display: flex;
  flex-direction: column;
  gap: 6px;
  white-space: normal;
}
</style>
